import * as types from 'modules/releases/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<Release>} ReleaseDataReducer */

/** @type {import('utils/ReduxUtils').EntityAdapter<Release>} */
const releaseAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {ReleaseDataReducer} state
 * @param {import('modules/global/generic.types').PageContent<Release>} action
 * @returns {ReleaseDataReducer}
 */
const addManyFromPage = (state, { payload: { content } }) => releaseAdapter.updateMany(state, content);

/**
 * Update release status after successful status change
 * @param {ReleaseDataReducer} state
 * @param {Object} action
 * @returns {ReleaseDataReducer}
 */
const updateReleaseStatus = (state, { payload: release }) => releaseAdapter.updateOne(state, release);

export default createReducer(releaseAdapter.getInitialState(), {
  [types.FETCH_RELEASES_SUCCESS]: addManyFromPage,
  [types.CREATE_RELEASE_SUCCESS]: releaseAdapter.addOne,
  [types.UPDATE_RELEASE_SUCCESS]: releaseAdapter.addOne,
  [types.DELETE_RELEASE_SUCCESS]: releaseAdapter.removeOne,
  [types.PATCH_RELEASE_STATE_SUCCESS]: updateReleaseStatus,
  [types.FETCH_RELEASE_BY_ID_SUCCESS]: releaseAdapter.addOne,
});
